<template>
  <div>
    <div class="time">
      <span>{{day}}</span>
      <b>:</b>
      <span>{{hour}}</span>
      <b>:</b>
      <span>{{min}}</span>
      <b>:</b>
      <span>{{second}}</span>
    </div>
    <div class="timeUnit">
      <div class="timeUnitCon">
        <span>天</span>
        <b></b>
        <span>时</span>
        <b></b>
        <span>分</span>
        <b></b>
        <span>秒</span>
      </div>
    </div>
  </div>
</template>

<script>
  import eventBus from '@/common/bus.js'
  export default {
    name: "ParentNode",
    props: {
      time: {           // 结束时间
        type:Number
      },
      curTime:{         // 当前时间
        type:Number
      },
      auctionId:{       // 产品id
        type:Number
      }
    },
    data() {
      return {
        endtTime: this.time,
        currentTime:this.curTime,
        day: '00',
        hour: '00',
        min: '00',
        second: '00',
        diffime:0,
        timer:null,
      };
    },
    mounted() {
      this.countTime()
      this.timer = setInterval(()=>{
        this.countTime()
      },1000)
    },
    methods: {
      // 倒计时
      countTime () {
        this.diffTime = this.endtTime - this.currentTime
        console.log(this.diffTime);
        if(this.diffTime>=0){
          let d = Math.floor(this.diffTime / 1000 / 60 / 60 / 24)
          this.day = d < 10 ? '0' + d : d
          // 时
          let h = Math.floor(this.diffTime / 1000 / 60 / 60 % 24 )
          this.hour = h < 10 ? '0' + h : h
          // 分
          let m = Math.floor(this.diffTime / 1000 / 60 % 60)
          this.min = m < 10 ? '0' + m : m
          // 秒
          let s = Math.floor(this.diffTime / 1000 % 60)
          this.second = s < 10 ? '0' + s : s

          this.currentTime += 1000

          // 等于0的时候不调用
          if (Number(this.hour) === 0 && Number(this.day) === 0 && Number(this.min) === 0 && Number(this.second) === 0) {
            this.timer = null
            eventBus.$emit('changeStaus',this.auctionId)
            return
          }
        }else{
          this.timer = null
          this.day = '00'
          this.hour = '00'
          this.min = '00'
          this.second = '00'
        }
      },
    },
    watch: {
      time(val){
        this.endtTime = val;
      },
      curTime(val){
        this.currentTime = val
      },
    },
  };
</script>
<style scoped lang="less">
  .time,.timeUnit{
    display: flex;
    justify-content: center;
    align-items: center;
    span{
      width: 56px;
      height: 48px;
      line-height: 48px;
      color: #ffffff;
      background: #333333;
      font-size: 30px;
      border-radius: 4px;
    }
    b{
      width: 15px;
      height: 48px;
      line-height: 48px;
      font-size: 30px;
      font-weight: 700;
    }
  }
  .timeUnit{
    margin-bottom: 20px;
    .timeUnitCon{
      display: flex;
      justify-content: center;
      align-items: center;
      width: 270px;
      border: 1px dashed #999;
      box-sizing: border-box;
    }
    span{
      font-size: 20px;
      height: 44px;
      line-height: 34px;
      color:rgba(51, 51, 51, 0.2);
      background:linear-gradient(rgba(0,0,0,.1),rgba(0,0,0,0));
    }
    b{
      height: 44px;
    }
  }
</style>
